import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import http from './utils/request'
const app = createApp(App);
app.use(createPinia());

let userSt;
if (process.env.NODE_ENV === 'development') {
  //本地调试，直接自己调用
  userSt = "AgAAAJxMTAAAAAAAAAAAAKS0OEo2nS/25e/KKcJiPmlb3szHyURwO1djHYtygu6MKGidNzwU0t2hbMQYbA8LDm2UYfq259qoneBQbyO72T1tlGH6tufaqJ3gUG8ju9k9zWHFCEF38BE0OT9fAJSJc22UYfq259qoneBQbyO72T0=";
} else {
  if (window.qfwebobject != null && window.qfwebobject.userST != null && typeof (window.qfwebobject.userST) != 'undefined' && window.qfwebobject.userST != '') {
    userSt = window.qfwebobject.userST;
  }
}

app.provide("userSt", userSt)
//设置http请求默认的st参数
http.defaults.params.st = userSt;

http.get("ActTask/GetUserActId")
  .then((res) => {
    if (res.Code == 0) {
      if (res.Obj == 11) {
        app.mount('#app')
      } else {
        window.location.href = "../ActTask" + res.Obj + "/index.html";
      }
    } else {
      app.mount('#app')
    }
  });

function QueryIndexInfo() {
  if (window.top !== window.self) {
    return window.top.leftDH.QueryIndex();
  }
  return null
  //return { Index: 4, Percentage: 50, Tips: '检测到多账号操作，当前账号翠珏获取效率调整为50%' };
}
app.provide("QueryIndexInfo", QueryIndexInfo)


